/*
 * @Author: your name
 * @Date: 2021-09-15 10:08:45
 * @LastEditTime: 2021-10-12 13:37:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \wapquote\src\modules\quote_table\table.ts
 */
// 通用表格

import merge from "lodash/merge";

declare var Hammer:any;

interface tableConf {
  dataprocess: any;
  ele: String;
  refresh: Number;
  tabconfig: any;
  tabindex: Number;
}

class Table {
  table_options:any = {}
  timer: any = null // 定时器
  nowX:any = 0
  constructor(options: any) {
    this.table_options = merge(this.table_options, options);
  }

  // 初始化表格 
  init() {
    let self = this;
    self.showtable();
  }

  showtable() {
    let self = this;
    self.maketable();
  }

  // 生成 table
  maketable() {
    let self = this;
    let _table = $(`#${self.table_options.ele}`);
    let data = self.table_options.data;
    let th = '',td='',result = '';
    if(data && data.length > 0){
        // 生成表头
        _table.html('');
        let tableWidth = (document.documentElement.offsetWidth-20) / self.table_options.col * (self.table_options.item.length)
        $(`#${self.table_options.ele}`).width(tableWidth)
        self.table_options.item.forEach((v:any,i:any) => {
            th += self.table_options.title.html(v)
        });
        th = `<tr>${th}</tr>`
        data.forEach((v:any,i:any) => {
            let _d = ''
            self.table_options.item.forEach((_v:any,_i:any) => {
                _d += self.table_options.item[_i].html(v,self.table_options.other)
            });
            td += `<tr>${_d}</tr>`
        });
        result = `<table><tbody>${th}${td}</tbody></table>`
        _table.html(result)
        self.bindFun();//绑定滑动
    }else{
      // 无数据
      $(`#${self.table_options.ele}`).width('')
      _table.html('');
      result = `<div class="bj-nodata">该品种暂无相关内容</div>`
      _table.html(result);
    }
    
  }

  bindFun(){
      // 给表格注册事件
    let self = this
    let dom:any = document.getElementById(`${self.table_options.ele}`);
    let _table: any = dom.querySelector('table');
    let timer:any

    var hemmertime = new Hammer(_table);
    var screenWidth = document.documentElement.offsetWidth

    var options = {
        endX : 0,
        nowX : self.nowX,
        tableWidth : _table.offsetWidth,
        liWidth : (screenWidth-self.table_options.padding) / self.table_options.col,
        _table:_table,
        showWith : screenWidth - self.table_options.padding
    }

    hemmertime.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL });
    hemmertime.on('panstart', function (e: any) {
        _table.style.transition = 'none';
    })

    hemmertime.on('panmove', function (e: any) {
        options.endX = e.deltaX
        let _moveX = options.nowX + options.endX
        if(_moveX > 0){
            _moveX = 0
        }
        if(_moveX + options.tableWidth - options.liWidth*self.table_options.col < 0){
            _moveX = -options.tableWidth + options.liWidth*self.table_options.col
        }
        _table.style.transform = 'translateX(' + _moveX + 'px)';
    })

    hemmertime.on('panend', function (e: any) {
        options.nowX = options.endX + options.nowX;
        _table.style.transition = 'transform .5s cubic-bezier(.17,.67,.84,.90)';
        self.setTransform(options)
        self.listAlignment(options)
        self.nowX = options.nowX
    })
  }

  setTransform(opsions: any) {
    // 滑动归位
    if (opsions.nowX > 0) {
      opsions.nowX = 0
    } else if (opsions.nowX + opsions._table.offsetWidth - opsions.showWith < 0) {
      opsions.nowX = -opsions._table.offsetWidth + opsions.showWith
    } else {
    }
    opsions._table.style.transform = 'translateX(' + opsions.nowX + 'px)';
  }

  listAlignment(opsions: any) {
    // 列对齐
    let _x = Math.abs(opsions.nowX) % opsions.liWidth
    if (_x > 0) {
      if (_x < (opsions.liWidth / 2)) {
        // 左侧列表不及1格
        opsions.nowX = opsions.nowX + _x
      } else {
        opsions.nowX = opsions.nowX + _x - opsions.liWidth
      }
    }
    opsions._table.style.transform = 'translateX(' + opsions.nowX + 'px)';
  }
}

export default Table